import React from 'react';
import { IconProps } from './types/Icon.type';

function QuoteEndIcon(props: IconProps) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 3C28 2.44771 27.5523 2 27 2L21.5158 2C20.9635 2 20.5158 2.44772 20.5158 3L20.5158 8.11009C20.5158 8.66238 20.9635 9.11009 21.5158 9.11009L22.9263 9.11009C23.4786 9.11009 23.9393 9.56268 23.8311 10.1043C23.5223 11.6514 22.4729 12.7956 20.846 13.2212C20.3458 13.352 19.9474 13.7719 19.9474 14.289L19.9474 15.9168C19.9474 16.5006 20.4479 16.9652 21.0222 16.8605C25.5098 16.0421 28 12.4739 28 7.91743L28 3ZM18.0526 3C18.0526 2.44771 17.6049 2 17.0526 2L11.5684 2C11.0161 2 10.5684 2.44771 10.5684 3L10.5684 8.11009C10.5684 8.66237 11.0161 9.11009 11.5684 9.11009L12.9789 9.11009C13.5312 9.11009 13.9919 9.56267 13.8838 10.1043C13.5749 11.6514 12.5255 12.7956 10.8986 13.2212C10.3984 13.352 10 13.7719 10 14.289L10 15.9168C10 16.5006 10.5005 16.9652 11.0748 16.8605C15.5625 16.0421 18.0526 12.4739 18.0526 7.91743L18.0526 3Z"
        fill="#EFEFEF"
      />
    </svg>
  );
}

export default QuoteEndIcon;
